import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  CompanyProfileData,
  CompanyProfileModel,
  LicenseNumberDetails,
} from "./types";

export const myProfileInitialstate: CompanyProfileModel = {
  companyProfileData: {
    _id: "",
    companyName: "",
    companyEmail: "",
    companyPicture: "",
    bannerImage: "",
    shippingAddress: {
      flatAddress: "",
      state: "",
      city: "",
      zipcode: "",
    },
    billingAddress: {
      flatAddress: "",
      state: "",
      city: "",
      zipcode: "",
    },
    mobileNo: "",
    website: "",
    facebookProfile: "",
    instagramProfile: "",
    xProfileLink: "",
    license: [],
  },
  licenseNumberDetails: [],
  deletionRequests: [],
  facilityLicenseListAPI: [],
  addedLicenseImport: [],
};
const CompanyProfileModuleSlice = createSlice({
  name: "comapanyProfile",
  initialState: myProfileInitialstate,
  reducers: {
    setCompanyProfileData: (
      state: CompanyProfileModel,
      action: PayloadAction<CompanyProfileData>,
    ) => {
      state.companyProfileData = action.payload;
    },

    setLicenseNumberData: (
      state: CompanyProfileModel,
      action: PayloadAction<any>,
    ) => {
      state.licenseNumberDetails = action.payload;
    },

    setDeletionRequestData: (
      state: CompanyProfileModel,
      action: PayloadAction<any>,
    ) => {
      state.deletionRequests = action.payload;
    },

    setFacilityLicenseListAPI: (
      state: CompanyProfileModel,
      action: PayloadAction<string[]>,
    ) => {
      state.facilityLicenseListAPI = action.payload;
    },

    setCompanyProfileFacilityList: (
      state: CompanyProfileModel,
      action: PayloadAction<LicenseNumberDetails[]>,
    ) => {
      state.licenseNumberDetails = action.payload;
    },

    setAddedLicenseImport: (
      state: CompanyProfileModel,
      action: PayloadAction<string[]>,
    ) => {
      state.addedLicenseImport = action.payload;
    },
  },
});

export const {
  setCompanyProfileData,
  setLicenseNumberData,
  setAddedLicenseImport,
  setDeletionRequestData,
  setFacilityLicenseListAPI,
  setCompanyProfileFacilityList,
} = CompanyProfileModuleSlice.actions;
export default CompanyProfileModuleSlice.reducer;
